import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../base/base.component';

import { WizardService } from '../../../services/wizard/wizard.service';
import { EventService } from '../../../services/event/event.service';

import { IWizardOptions } from '../../../models';
import { IAvailabilityWindowSchema, IWorkDaysSchema, TimeAfterPipe, UserPlan } from 'common-lib';

import * as _ from 'lodash';
/**
 * Time Picker's values are determined by Wizard DefaultOptions
 */
@Component({
    selector: 'wizard-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['../../form-styles.scss'],
    providers: [TimeAfterPipe]
})
export class TimePickerComponent extends BaseComponent implements OnInit {
    private defaultOptionsSubscription: Subscription;
    public availabilityWindows: IAvailabilityWindowSchema;
    public isLoading = true;
    public meetingLength = 60;
    public hasTimeForMoreRanges = true;
    public isBasicUser = false;
    public showCalendar = false;
    public timezone = 'America/Toronto';

    constructor(private wizardService: WizardService, private eventService: EventService) {
        super();
    }

    ngOnInit() {
        this.setDefaultAvailabilityWindows();
        this.subscribeToMeetingDefaultsUpdates();
        this.isBasicUser = this.wizardService.currentUser.plan === UserPlan.Basic;
        this.timezone = this.wizardService.currentUser.timezone;
    }

    ngOnDestroy() {
        this.defaultOptionsSubscription.unsubscribe();
    }

    private subscribeToMeetingDefaultsUpdates() {
        this.defaultOptionsSubscription = this.wizardService.onNewDefaultOptions$.subscribe(
            (defaults: IWizardOptions) => {
                if (defaults) {
                    this.meetingLength = defaults.meetingLength || 60;
                    if (defaults.availabilityWindows) this.updateAvailabilityWindows(defaults.availabilityWindows);
                    this.isLoading = false;
                }
            }
        );
    }

    private createDefaultAvailabilityWindows() {
        return {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: []
        };
    }

    private setDefaultAvailabilityWindows() {
        if (this.wizardService.options.availabilityWindows) {
            this.availabilityWindows = this.wizardService.options.availabilityWindows;
        } else {
            this.availabilityWindows = this.createDefaultAvailabilityWindows();
        }

        this.eventService.clearErrorMessage('availability');
        this.isLoading = false;
    }

    private updateAvailabilityWindows(availabilityWindows: IAvailabilityWindowSchema) {
        this.availabilityWindows = availabilityWindows;
        this.wizardService.updateOptions({ availabilityWindows });
        this.eventService.clearErrorMessage('availability');
    }

    public handleSaveAvailabilityWindows(event: {
        availabilityWindows: IAvailabilityWindowSchema;
        workDays: IWorkDaysSchema;
    }) {
        this.updateAvailabilityWindows(event.availabilityWindows);
    }
}
